// NPM
import React, { useState, useEffect } from "react";
import _ from "lodash";

// State
import { useSelector } from "react-redux";

// api
import api from "./api";

// Services
import renderService from "services/renderService";

// Components
import RidingProjectionsTable from "./RidingProjectionsTable";
import RegionSelector from "../RegionSelector";

function RidingProjections() {
  // State
  const [ridingProjectionData, setRidingProjectionData] = useState([]);
  const [ridingRegion, setRidingRegion] = useState("");
  const campaignConfig = useSelector((state) => state.campaignConfig.value);
  const region = useSelector((state) => state.region.value);

  const availableRegions = _.chain(ridingProjectionData)
    .filter((rpd) => rpd.region !== "NATIONAL")
    .uniqBy("region")
    .map((rpd) => ({ name: rpd.region }))
    .value();

  const loadData = async () => {
    const ridingProjectionApiData = await api.loadRidingProjections();
    setRidingProjectionData(ridingProjectionApiData);
  };

  const currentRidingProjectionData = ridingProjectionData.filter(
    (rpd) => ridingRegion === "NATIONAL" || ridingRegion === rpd.region,
  );

  // Hooks
  useEffect(() => {
    if (!ridingRegion) {
      setRidingRegion(region);
    }
  }, [region, ridingRegion]);
  useEffect(() => {
    if (ridingProjectionData.length === 0) {
      loadData();
    }
  }, [ridingRegion, ridingProjectionData]);

  const onRegionSelect = (regionName) => {
    setRidingRegion(regionName);
  };

  if (!renderService.canRender([ridingProjectionData, region])) {
    return null;
  }

  const title = _.get(campaignConfig, "sections.RidingProjections.title");
  const description = _.get(
    campaignConfig,
    "sections.RidingProjections.description",
  );

  return (
    <div className="RidingProjections Signal__section">
      {title && <h2 className="Signal__section-title">{title}</h2>}
      {description && (
        <p className="Signal__section-description">{description}</p>
      )}

      {availableRegions.length > 0 && (
        <div className="RidingProjections__regionSelector">
          <RegionSelector
            regions={availableRegions}
            selected={ridingRegion}
            onSelect={onRegionSelect}
            showNational
          />
        </div>
      )}
      <RidingProjectionsTable ridingProjections={currentRidingProjectionData} />
    </div>
  );
}

export default RidingProjections;
